import { render, staticRenderFns } from "./sopModal.vue?vue&type=template&id=8205137e&"
import script from "./sopModal.vue?vue&type=script&lang=js&"
export * from "./sopModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports